import CustomButton from "../../../../components/CustomButton";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import { KTSVG } from "../../../../helpers/KTSVG";
import SvgIcon from "../../../../helpers/SvgIcon";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  setClientsSelectedActiveExpedition,
  setClientsSelectedActiveExpeditionForNode,
} from "../../../../redux/reducer/expedition.reducer";
import NodeTransferActiveExpeditionModal from "../NodeTransferActiveExpeditionModal";
import RouteTransferActiveExpeditionModal from "../RouteTransferActiveExpeditionModal";

const CustomHeaderComponent = () => {
  const { selectedItems } = useTableCtx() || {};

  const dispatch = useAppDispatch();
  const {
    expedition: {
      clientsSelectedActiveExpedition,
      clientsSelectedActiveExpeditionForNode,
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
    transport: state.transport,
  }));

  const handleOpenRouteModal = () => {
    if (selectedItems?.length) {
      dispatch(setClientsSelectedActiveExpedition(selectedItems));
    }
  };

  const handleOpenNodeModal = () => {
    if (selectedItems?.length) {
      dispatch(setClientsSelectedActiveExpeditionForNode(selectedItems));
    }
  };

  return (
    <>
      <div className="mb-5 d-flex justify-content-between align-items-center">
        <div className="mb-14" />

        <div>
          {selectedItems && selectedItems.length > 0 && (
            <>
              <CustomButton
                variant="contained"
                className="mt-1 me-1"
                tooltipTitle="Transfer ruta"
                onClick={handleOpenRouteModal}>
                <KTSVG
                  path="/media/svg/expedition/route.svg"
                  className="svg-icon-1"
                  fill="white"
                />
              </CustomButton>

              <CustomButton
                variant="contained"
                className="mt-1 me-1"
                tooltipTitle="Transfer nod"
                onClick={handleOpenNodeModal}>
                <SvgIcon type="TRANSFER_NODE" fill="white" />
              </CustomButton>
            </>
          )}
        </div>
      </div>
      {clientsSelectedActiveExpedition.length > 0 && (
        <RouteTransferActiveExpeditionModal />
      )}
      {clientsSelectedActiveExpeditionForNode.length > 0 && (
        <NodeTransferActiveExpeditionModal />
      )}
    </>
  );
};

export default CustomHeaderComponent;
